import React from "react";
import { Divider, Tag, Typography } from "antd";

interface ResumeSkillsProps {
  skills: string[];
}
const ResumeSkills: React.FC<ResumeSkillsProps> = ({ skills }) => {
  const skillsTagColor = [
    "blue",
    "purple",
    "cyan",
    "green",
    "magenta",
    "pink",
    "geekblue",
  ];
  return (
    <div className="resume-preview-card">
      <div className="resume-preview-card-header">
        <div className="resume-preview-card-header-title">
          <span className="material-symbols-outlined" style={{ margin: 0 }}>
            code_blocks
          </span>
          <Typography.Title level={5} style={{ margin: 0 }}>
            Skills
          </Typography.Title>
        </div>
      </div>
      <Divider style={{ margin: 0 }} />
      <div className="resume-preview-skills-list">
        {skills.map((s, i) => (
          <Tag
            key={i}
            color={
              skillsTagColor[Math.floor(Math.random() * skillsTagColor.length)]
            }
          >
            {s}
          </Tag>
        ))}
      </div>
    </div>
  );
};

export default ResumeSkills;
